import { LuChevronDown } from "react-icons/lu";
import { ImageWithFallback } from "./figma/image-with-fallback";
import { motion } from "framer-motion";

export function HeroSection() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  return (
    <section className="h-screen snap-start flex flex-col bg-white px-5 py-12">
      <motion.div
        className="flex-1 flex flex-col items-center justify-center max-w-2xl mx-auto w-full"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false }}
      >
        <motion.h1
          variants={itemVariants}
          className="text-center mb-16"
          style={{ fontSize: "2.25rem", fontWeight: 800, lineHeight: 1.3 }}
        >
          내가 찾던 <span className="text-blue-600">동네 손님</span>,
          <br />
          마감히어로에
          <br />
          이미 있어요
        </motion.h1>

        <motion.div
          variants={itemVariants}
          className="w-full bg-gradient-to-br from-blue-600 to-blue-700 rounded-3xl overflow-hidden shadow-xl mb-6"
        >
          <div className="relative w-full h-64">
            <ImageWithFallback
              src="https://cdn-mahi.com/map-location-img.png"
              alt="동네 손님"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-blue-700/80 to-transparent" />
          </div>
          <div className="p-8 text-center">
            <p
              className="text-white/90"
              style={{ fontSize: "1.25rem", fontWeight: 600, lineHeight: 1.6 }}
            >
              200,000명의 동네 손님,
              <br />
              1,000명의 사장님이 함께 해요
            </p>
          </div>
        </motion.div>

        <motion.div variants={itemVariants}>
          <LuChevronDown className="w-6 h-6 text-gray-400 animate-bounce" />
        </motion.div>
      </motion.div>
    </section>
  );
}
